<template>
  <v-layout wrap>
    <v-flex xs12 pb-0>
      <v-layout wrap align-center>
        <v-flex xs12 mt-3>
          <h1 class="headline">{{ $t('autoInfo.title') }} - {{ autoTitle }}</h1>
          <auto-form v-if="autoId" :autoId="autoId" />
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex';
import AutoForm from '@/components/auto/AutoForm/AutoForm.vue';

export default {
  name: 'AutoInfoPage',
  components: {
    AutoForm,
  },
  data() {
    return {
      autoId: null,
    };
  },
  computed: {
    ...mapGetters({
      autoTitle: 'auto/getAutoTitle',
    }),
  },
  created() {
    this.autoId = this.$route.params.autoId;
  },
};
</script>

<style lang="scss" scoped></style>
